import { NovaLogoWithDate } from '@hub/components/logo/logo';
import { Stack, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';

interface Props {
  uniqId: string;
  snapshotId?: string;
  title: string;
}

const BillHeader = ({ uniqId, snapshotId, title }: Props) => {
  const { palette } = useTheme();
  const { isMobile } = useBreakpoints();

  return (
    <Stack direction="row" gap={4} sx={{ alignItems: 'center' }}>
      <NovaLogoWithDate />
      <Stack direction="column" marginRight={16}>
        <Typography
          sx={{ fontSize: isMobile ? '24px' : '42px', fontWeight: 700 }}
        >
          {title}
        </Typography>
        <Typography variant="body2" color={palette.primary.main}>
          #{uniqId}
        </Typography>
        {snapshotId && (
          <Typography variant="body2" color={palette.text.secondary}>
            Ref.ID {snapshotId}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default BillHeader;
